// extracted by mini-css-extract-plugin
export var content = "FeaturedEventsPanel-module--content--7c2cb";
export var featImage = "FeaturedEventsPanel-module--featImage--0eb09";
export var label = "FeaturedEventsPanel-module--label--35f7c";
export var rightCol = "FeaturedEventsPanel-module--rightCol--29de8";